module.exports = __webpack_public_path__ + "static/capsule-preview-violons-1.c8883e0c.png";


//////////////////
// WEBPACK FOOTER
// ./images/capsule-preview-violons-1.png
// module id = 907
// module chunks = 168707334958949